import { combineReducers } from "redux";
import { PurchaseReducer } from "./purchase/PurchaseReducers"
import { IndirectReducer } from "./indirect/IndirectReducer"
import { MaintenanceReducer } from "./maintenance/MaintenanceReducer"
import{TelematicsReducer} from "./telematics/TelematicsReducer"
import {CollateralReducer} from "./collateral/CollateralReducer"
import LoginReducer from "./common/LoginReducer"
import UserProfileReducer from "./common/UserProfileReducer"
import {NotificationsReducer} from "./notifications/NotificationsReducer"
import NavigationReducer from "./common/NavigationReducer"

export const reducers = combineReducers ({
    LoginReducer,
    UserProfileReducer,
    NavigationReducer,  
    PurchaseReducer,
    MaintenanceReducer,
    CollateralReducer,
    IndirectReducer,
    TelematicsReducer,
    NotificationsReducer
})